import type React from "react";
import { Tab, TabList, TabPanel, Tabs } from "react-tabs";
import type { DisplayMode } from "../../types";
import styles from "./index.module.scss";

interface TabItem {
  key: string;
  label: string;
  content: React.ReactNode;
}

interface TabContainerProps {
  mode: DisplayMode;
  tabs: TabItem[];
  selectedIndex: number;
  onSelect: (index: number) => void;
  maxTabs?: number | undefined;
  className?: string | undefined;
}

const TabContainer: React.FC<TabContainerProps> = ({
  mode,
  tabs,
  selectedIndex,
  onSelect,
  maxTabs,
  className = "",
}) => {
  const displayTabs = maxTabs && mode === "compact" ? tabs.slice(0, maxTabs) : tabs;
  const containerClass = mode === "compact" ? styles["container--compact"] : styles["container"];

  return (
    <div className={`${containerClass} ${className}`}>
      <Tabs selectedIndex={selectedIndex} onSelect={onSelect}>
        <TabList className={mode === "compact" ? styles["tabList--compact"] : styles["tabList"]}>
          {displayTabs.map((tab) => (
            <Tab
              key={tab.key}
              className={mode === "compact" ? styles["tab--compact"] : styles["tab"]}
              selectedClassName={
                mode === "compact" ? styles["tab--compact--selected"] : styles["tab--selected"]
              }
            >
              {tab.label}
            </Tab>
          ))}
          {mode === "compact" && maxTabs && tabs.length > maxTabs && (
            <span className={styles["moreTabs"]}>+{tabs.length - maxTabs}</span>
          )}
        </TabList>

        {displayTabs.map((tab) => (
          <TabPanel key={tab.key}>{tab.content}</TabPanel>
        ))}
      </Tabs>
    </div>
  );
};

export default TabContainer;
